<div class="flex justify-end mt-7">
  <lh-docs-zip-download
    *ngIf="rows.length > 0"
    [documentIds]="documentIds"
  ></lh-docs-zip-download>
</div>

<!--div class="d-lg-none bg-light product-docs-toolbar">
  <div class="row">
    <div class="col-6">
      <lh-docs-zip-download
        *ngIf="rows.length > 0"
        [documentIds]="documentIds"
      ></lh-docs-zip-download>
    </div>
    <div class="col-6" (click)="show()">
      <button class="btn btn-link">
        <span class="icon icon-large icon-filter"></span>
      </button>
    </div>
  </div>
</div-->
